import { Link, createFileRoute, notFound } from '@tanstack/react-router'
import { ArrowLeft, Frown } from 'lucide-react'

export const Route = createFileRoute('/$')({
  loader: () => {
    throw notFound()
  },
  component: NotFoundPage,
  head: () => ({
    meta: [
      { title: '404 — Page Not Found | Suriyaprakash Somu' },
      { name: 'title', content: '404 — Page Not Found | Suriyaprakash Somu' },
      {
        name: 'description',
        content: 'The page you are looking for does not exist.',
      },
      { name: 'robots', content: 'noindex, follow' },
      {
        name: 'ai-summary',
        content:
          'This URL does not resolve to a page on the Suriyaprakash Somu portfolio.',
      },
      { property: 'og:title', content: '404 — Page Not Found' },
      {
        property: 'og:description',
        content: 'The requested page does not exist.',
      },
      { name: 'twitter:title', content: '404 — Page Not Found' },
      {
        name: 'twitter:description',
        content: 'The requested page does not exist.',
      },
    ],
  }),
})

function NotFoundPage() {
  return (
    <div className="flex min-h-[calc(100vh-8rem)] items-center justify-center px-5 sm:px-6">
      <div className="text-center">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-cream-100 sm:h-20 sm:w-20">
          <Frown className="h-8 w-8 text-forest sm:h-10 sm:w-10" />
        </div>
        <h1 className="font-heading mt-6 text-6xl leading-none tracking-[-0.03em] text-ink sm:text-7xl lg:text-8xl">
          404
        </h1>
        <p className="body-large mt-4 max-w-md sm:mt-5">
          The page you are looking for does not exist or has been moved.
        </p>
        <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row sm:justify-center sm:gap-4">
          <Link
            to="/"
            className="focus-ring inline-flex items-center gap-2 rounded-full bg-forest px-6 py-3.5 text-sm font-bold text-white transition-colors hover:bg-forest-strong active:scale-95"
          >
            <ArrowLeft className="h-4 w-4" />
            Back to home
          </Link>
          <Link
            to="/blog"
            className="focus-ring inline-flex items-center gap-2 rounded-full border border-line bg-card px-6 py-3.5 text-sm font-bold text-ink transition-colors hover:border-forest hover:text-forest active:scale-95"
          >
            Browse blog
          </Link>
        </div>
      </div>
    </div>
  )
}
